import { Component } from '@angular/core';
import { Nav, NavController, NavParams } from 'ionic-angular';
import { ImageViewerController } from 'ionic-img-viewer';
import { CartPage } from '../cart/cart';
import { Storage } from '@ionic/storage';
import { ShariahServiceProvider } from '../../providers/shariah-service/shariah-service';

@Component({
  selector: 'page-slideContent',
  templateUrl: 'slidecontent.html'
})

export class SlideContentPage {
  pages: Array<{ title: string; component: any }>;
  
  imageViewerCtrl: ImageViewerController;
  user_id: Number;
  subportfolio_id: Number;
  attachment: any;

  slideID: any;
  slideImage: any;
  slideTitle: any;
  slideDesc: any;

  subscription_status:any;
  cart_status:any;
  cart: any[];
  contents: any[];

  constructor(
    public navCtrl: NavController,
    public nav: Nav,
    public navParams: NavParams,
    private shariahService: ShariahServiceProvider,
    private storage: Storage
  ) {
    this.contents = [];

    this.subportfolio_id = navParams.get('subportfolio_id');
    this.pages = [{ title: 'Cart', component: CartPage }];
  }

  async ngOnInit() {
    this.user_id = await this.storage.get('user_id');
    
    var cart_data = await this.storage.get('cart');

    if (cart_data) {
      this.cart = JSON.parse(cart_data);

      if(this.cart.indexOf(this.subportfolio_id) > -1 ){
        this.cart_status = true;
      }
    } else {
      this.cart = [];
    }

    this.getPaymentStatus(this.user_id, this.subportfolio_id);
    this.getContents(this.subportfolio_id);
  }

  changeSlide(id, attachments, title, description) {
    // console.log(attachments[0]);
    var input = document.getElementById('slideDesc');
    input.scrollTop = 0;
    this.slideID    = id;
    this.slideImage = attachments;
    this.slideTitle = title;
    this.slideDesc  = description;
  }

  onClick(imageToView) {
    const viewer = this.imageViewerCtrl.create(imageToView);
    viewer.present();
  }

  goToCart() {
    this.navCtrl.push(this.pages[0].component);
  }

  getContents(subportfolio_id) {
    this.shariahService.getContents(subportfolio_id).subscribe((data: any) => {
      let first = true;

      for (let content of data) {
          if (this.subscription_status == true) {
          if (first) {
            this.slideID    = content.id;
            this.slideImage = content.attachments;
            this.slideTitle = content.title;
            this.slideDesc  = content.description;

            first = false;
          }
          
          this.contents.push(content);
        } else {
          if (content.is_preview == 1) {
            if (first) {
              this.slideID    = content.id;
              this.slideImage = content.attachments;
              this.slideTitle = content.title;
              this.slideDesc  = content.description;

              first = false;
            }

            this.contents.push(content);
          }
        }
      }
        console.log(this.contents);
      }, err => console.log(err));
  }

  getPaymentStatus(user_id, subportfolio_id) {
    this.shariahService.getUserBoughtItems(user_id, subportfolio_id).subscribe((data: any) => {
      this.subscription_status = data.subportfolio_status;
    }, err => console.log(err));
  }

  addToCart(sub_id) {
    if(this.cart.indexOf(sub_id) > -1 ){
      console.log('already added to cart');
    } else {
      this.cart.push(sub_id);

      this.storage.set('cart', JSON.stringify(this.cart));

      this.cart_status = true;
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/slidecontent/slidecontent.ts